<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-fill-heart`]" width="1em" height="1em" v-bind="$attrs"><path d="M23.64 10.888l.36.375.36-.375c4.171-4.335 10.898-4.593 15.035-.293 4.142 4.305 4.007 10.878.388 16.52-1.999 3.115-5.02 6.612-8.039 9.39-1.508 1.388-3.006 2.588-4.366 3.469-1.341.868-2.5 1.394-3.378 1.522-.878-.128-2.037-.654-3.378-1.522-1.36-.88-2.858-2.08-4.366-3.469-3.018-2.778-6.04-6.275-8.04-9.39-3.618-5.642-3.753-12.215.389-16.52 4.137-4.3 10.863-4.042 15.034.293z" stroke="#000"/></svg>
</template>
<script>

export default {
  name: 'IconFillHeart',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
